/* eslint-disable @typescript-eslint/no-var-requires */
import { decode, encode } from "@stablelib/base64";
import { seal } from "sealed-box";
import nacl from "tweetnacl";

let textEncoder: TextEncoder;

// annoying thing where the window object from jsdom doesn't have these objects, but also neither does webpack's `util` polyfill, so we need to detect if we're REALLY in the browser and use the browser builtins if so, and use the util module for nodejs if not.
if (globalThis.TextEncoder) {
  textEncoder = new TextEncoder();
} else {
  textEncoder = new (require("util").TextEncoder)();
}

export const encodeBytesForStorage = encode;
export const decodeBytesFromStorage = decode;

export type Base64EncodedBuffer = string;

// Create a new keypair for encrypting secrets
export const generateAsymmetricKeyPair = () => {
  return stringifyKeyPair(nacl.box.keyPair());
};

export const stringifyKeyPair = (keyPair: nacl.BoxKeyPair): { publicKey: Base64EncodedBuffer; secretKey: Base64EncodedBuffer } => ({
  publicKey: encodeBytesForStorage(keyPair.publicKey),
  secretKey: encodeBytesForStorage(keyPair.secretKey),
});

export const parseStringKeyPair = (keyPair: { publicKey: Base64EncodedBuffer; secretKey: Base64EncodedBuffer }) => ({
  publicKey: decodeBytesFromStorage(keyPair.publicKey),
  secretKey: decodeBytesFromStorage(keyPair.secretKey),
});

export const encryptApplicationSecret = (value: string, publicKey: Uint8Array) => {
  const encodedValue = textEncoder.encode(value);
  return encodeBytesForStorage(seal(encodedValue, publicKey));
};
